import React from "react";

export default function Reminder({ text, date, borderColor, dateColor,circleColor }) {
  return (
    <div
      className={
        "relative ml-3 border-l-2 pl-4 before:absolute before:w-3 before:h-3 before:rounded-full before:top-1/2 before:-translate-y-1/2 before:-left-5 " +
        borderColor + circleColor
      }
    >
      <h1 className=" font-bold">{text}</h1>
      <span className={dateColor + " text-sm"}>{date}</span>
    </div>
  );
}
